import { createSlice } from "@reduxjs/toolkit";
import { sleep } from "../../common/utils/utils";
import { localAPI, anandaAPI } from "../../api/nodeRedApi/axiosApi";
import { addSnackAsync } from "../../app/coreSlice";

import {
  getAlerts as getAlertsDUMMY,
  addAlert as addAlertDUMMY,
  updateAlert as updateAlertDUMMY,
  removeAlert as removeAlertDUMMY,
  activateAlert as activateAlertDUMMY,
} from "../../api/fakeApi/alerts";
import {
  getAlerts as getAlertsAPI,
  addAlert as addAlertAPI,
  updateAlert as updateAlertAPI,
  removeAlert as removeAlertAPI,
  activateAlert as activateAlertAPI,
} from "../../api/nodeRedApi/alerts";

export const alertsSlice = createSlice({
  name: "alerts",
  initialState: {
    loader: null,
    error: null,
    alerts: null,
  },
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },

    setAlerts: (state, action) => {
      state.alerts = action.payload;
    },
  },
});

export const { setLoader, setError, setAlerts } = alertsSlice.actions;

export const getAlerts = (project) => async (dispatch) => {
  console.log("GET");
  dispatch(setLoader("LOADING"));
  let alerts = [];
  switch (project?.id) {
    case "LOCAL":
    case "ANANDA":
      alerts = await getAlertsAPI(project.id === "LOCAL" ? localAPI : anandaAPI);
      break;
    default:
      alerts = getAlertsDUMMY();
      await sleep(1000);
      break;
  }
  alerts.map(
    (zone) =>
      (zone.alerts = zone.alerts.sort(
        (a, b) => (a.designation > b.designation && 1) || -1
      ))
  );

  dispatch(setAlerts(alerts));
  dispatch(setLoader(null));
};

export const addAlert =
  (project, { sensorId, designation, severity, type, value }) =>
  async (dispatch) => {
    console.log("ADD");
    dispatch(setLoader("ADD_ALERT"));
    switch (project.id) {
      case "LOCAL":
    case "ANANDA":
        addAlertAPI(
          project.id === "LOCAL" ? localAPI : anandaAPI,
          sensorId,
          designation,
          severity,
          type,
          value,
          false
        );
        break;
      default:
        addAlertDUMMY(sensorId, designation, severity, type, value, false);
        await sleep(1000);
        break;
    }
    dispatch(addSnackAsync("success", "ALERT_ADDED"));
    dispatch(setLoader(null));
  };

export const updateAlert =
  (project, { id, sensorId, designation, severity, type, value, active }) =>
  async (dispatch) => {
    console.log("UPDATE");
    dispatch(setLoader("UPDATE_ALERT"));
    switch (project.id) {
      case "LOCAL":
    case "ANANDA":
        updateAlertAPI(
          project.id === "LOCAL" ? localAPI : anandaAPI,
          id,
          sensorId,
          designation,
          severity,
          type,
          value,
          active
        );
        break;
      default:
        updateAlertDUMMY(
          id,
          sensorId,
          designation,
          severity,
          type,
          value,
          active
        );
        await sleep(2000);
        break;
    }
    dispatch(addSnackAsync("success", "ALERT_UPDATED"));
    dispatch(setLoader(null));
  };

export const activateAlert = (project, id, active) => async (dispatch) => {
  console.log("UPDATE");
  dispatch(setLoader("UPDATE_ALERT"));
  switch (project.id) {
    case "LOCAL":
    case "ANANDA":
      activateAlertAPI(project.id === "LOCAL" ? localAPI : anandaAPI, id, active);
      break;
    default:
      activateAlertDUMMY(id, active);
      await sleep(2000);
      break;
  }
  dispatch(addSnackAsync("success", "ALERT_UPDATED"));
  dispatch(setLoader(null));
};

export const removeAlert = (project, id) => async (dispatch) => {
  console.log("REMOVE id: %o", id);
  dispatch(setLoader("REMOVE_ALERT"));
  switch (project.id) {
    case "LOCAL":
    case "ANANDA":
      removeAlertAPI(project.id === "LOCAL" ? localAPI : anandaAPI, id);
      break;
    default:
      removeAlertDUMMY(id);
      await sleep(2000);
      break;
  }
  dispatch(addSnackAsync("success", "ALERT_REMOVED"));
  dispatch(setLoader(null));
};

export const selectLoader = (state) => state.alerts.loader;
export const selectError = (state) => state.alerts.error;
export const selectAlerts = (state) => state.alerts.alerts;
export const selectSelectedProject = (state) =>
  state.authentication.selectedProject;

export default alertsSlice.reducer;
